import AgentItem from './AgentItem';

export default AgentItem;
